/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  CompetenceMatrixDto,
  PerformanceFormCompetenceGroupQueryDto,
  CompetenceMatrixQueryDto,
} from './models';

/**
 * CompetenceMatrixApi - API class
 */
export class CompetenceMatrixApi extends LinqService {

  /**
   * Creates a new CompetenceMatrixApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: CompetenceMatrixDto, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param competenceMatrices 
   */
  addOrUpdateBulk(competenceMatrices?: Array<CompetenceMatrixDto>, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/AddOrUpdateBulk`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = competenceMatrices;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/GetAsync`;
    let query = this.createQuery<CompetenceMatrixDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param employeeId 
   */
  getCompetenceMatricesForEmployee(employeeId?: string, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/GetCompetenceMatricesForEmployee`;
    let query = this.createQuery<CompetenceMatrixQueryDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'employeeId', value: employeeId && employeeId.toString() });
    query = query.withOptions(options);

    return query;
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/GetTranslatedAsync`;
    let query = this.createQuery<CompetenceMatrixDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/List`;
    let query = this.createQuery<CompetenceMatrixDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listCompetenceMatrixOfCurrentUser(options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/ListCompetenceMatrixOfCurrentUser`;
    let query = this.createQuery<CompetenceMatrixQueryDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param performanceFormDetailId 
   */
  listCompetenceOfTitle(performanceFormDetailId?: string, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/ListCompetenceOfTitle`;
    let query = this.createQuery<PerformanceFormCompetenceGroupQueryDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'performanceFormDetailId', value: performanceFormDetailId && performanceFormDetailId.toString() });
    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/ListTranslated`;
    let query = this.createQuery<CompetenceMatrixDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: CompetenceMatrixDto, options?: QueryOptions) {
    // create query
    const url = `/CompetenceMatrix/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
